module.exports = __webpack_public_path__ + "static/media/video-real-estate-3.359a1b5e.mp4";